import moment from 'moment'
import pluralize from 'pluralize'

import { DEFAULT_MOMENT_FORMAT, DEFAULT_MOMENT_FORMAT_WITH_TIME } from 'Global/constants'

/**
 * Returns a formatted date string.
 * @param {string} dateTimeString
 * @returns {string} Formatted date string
 */
export const getFormattedDateString = dateTimeString => {
  return moment(dateTimeString).format(DEFAULT_MOMENT_FORMAT)
}

/**
 * Returns a formatted date time string.
 * @param {string} dateTimeString
 * @returns {string} Formatted date string
 */
export const getFormattedDateTimeString = dateTimeString => {
  return moment(dateTimeString).format(DEFAULT_MOMENT_FORMAT_WITH_TIME)
}

export const getDurationInText = durationSeconds => {
  const hours = moment.utc(moment.duration(durationSeconds, 's').asMilliseconds()).format('HH')
  const minutes = moment.utc(moment.duration(durationSeconds, 's').asMilliseconds()).format('mm')
  const seconds = moment.utc(moment.duration(durationSeconds, 's').asMilliseconds()).format('ss')

  if (hours && parseInt(hours, 10) > 0) {
    return `${hours} ${pluralize('hours', hours)}, ${minutes} ${pluralize('minutes', minutes)} minutes, and ${seconds} ${pluralize(
      'seconds',
      seconds,
    )}`
  } else if (minutes && parseInt(minutes, 10) > 0) {
    return `${minutes} ${pluralize('minutes', minutes)} and ${seconds} ${pluralize('seconds', seconds)}`
  } else {
    return `${seconds} ${pluralize('seconds', seconds)}`
  }
}

/**
 * Returns whether a given date/date-string is in the past (rounded to a day).
 * @param {string|number} date
 * @returns {boolean} - whether the date is in the past (rounded to a day).
 */
export const isInPast = date => {
  const momentObject = moment(date)

  if (momentObject.isValid()) {
    return momentObject.isBefore(moment(), 'day')
  }

  return true
}
